import React from 'react';

// ============================================================================
// ESTILOS
// ============================================================================
import {
  Container,
  LogoWrapper,
  LogoImage,
  Title,
  SubTitle,
} from './Maintenance.styles';

// ============================================================================
// CONSTANTES
// ============================================================================

/** Logotipo exibido no tapume de manutenção. */
const LOGO_URL =
  'https://conectapontos.com/hosts/conectapontos.com/images/logoHeader.png';

// ============================================================================
// COMPONENTE
// ============================================================================

/**
 * Tapume de "Em manutenção".
 *
 * Exibido no lugar de toda a aplicação quando o modo de manutenção está ativo
 * (ver `utils/maintenanceMode`).
 */
const Maintenance: React.FC = () => (
  <Container>
    <LogoWrapper>
      <LogoImage src={LOGO_URL} alt="Logo" />
    </LogoWrapper>

    <Title>Estamos em manutenção</Title>

    <SubTitle>
      Nossa plataforma está passando por uma atualização para melhorar a sua
      experiência. Voltamos em breve — agradecemos a compreensão.
    </SubTitle>
  </Container>
);

export default Maintenance;
